import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button, Form, Alert, Spinner } from "react-bootstrap";
import { createWriteOff } from "../../afinanceapi";
import { FaCheck, FaTimes } from "react-icons/fa";
import AppToast from "../Toasts/AppToast";
import { useToast } from "../Toasts/useToast";

export default function WriteOffModal({ show, onHide, account }) {
  const navigate = useNavigate();
  const [writeOffNote, setWriteOffNote] = useState("");
  const [writeOffDate, setWriteOffDate] = useState(
    () => new Date().toISOString().split("T")[0]
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toast, showToast, hideToast } = useToast();
  const [closeAlert, setCloseAlert] = useState(false);
  const [hiddenForSuccess, setHiddenForSuccess] = useState(false);

  const handleSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      await createWriteOff({
        accountId: account._id,
        writeOffDate,
        writeOffNote,
        writeOffPracticeNumber: "",
      });

      showToast("success", "Write-off created successfully!");
      setHiddenForSuccess(true);
      setTimeout(() => {
        onHide();
        navigate(0);
      }, 2500);
    } catch (error) {
      console.error("Failed to create write-off:", error);
      showToast("error", "Failed to create write-off. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  function handleClose() {
    setCloseAlert(true);
  }

  return (
    <>
    <Modal show={show && !hiddenForSuccess} onHide={handleClose} centered>
      <Modal.Header closeButton={!closeAlert}>
        <Modal.Title className="text-primary">Write Off Account</Modal.Title>
      </Modal.Header>

      {closeAlert && (
        <Alert
          variant="info"
          className="w-100 d-flex align-items-center justify-content-between mx-0 mb-0 fs-6 fw-normal border-0 rounded-0"
        >
          <span>
            Are you sure you want to close? Changes will not be saved.
          </span>
          <div className="ms-auto d-flex">
            <Button
              variant="outline-primary"
              className="btn btn-outline-primary me-1"
              onClick={() => {
                setCloseAlert(false);
                onHide();
              }}
            >
              <FaCheck />
            </Button>
            <Button
              variant="outline-secondary"
              className="btn btn-outline-secondary me-1"
              onClick={() => setCloseAlert(false)}
            >
              <FaTimes />
            </Button>
          </div>
        </Alert>
      )}

      <Modal.Body>
        <h5 className="text-primary mb-3">
          {account?.accountFullNames} {account?.accountLastName}
        </h5>

        <Alert variant="warning" className="mb-3">
          This will write off the <strong>full outstanding balance</strong> for
          this account. All invoices with outstanding amounts will be marked as{" "}
          <strong>Written Off</strong>.
        </Alert>

        <Form.Group className="mb-3">
          <Form.Label className="fw-bold">Write Off Date:</Form.Label>
          <Form.Control
            type="date"
            size="sm"
            value={writeOffDate}
            onChange={(e) => setWriteOffDate(e.target.value)}
            style={{ width: "auto" }}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label className="fw-bold">Note:</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Enter a reason for the write-off..."
            value={writeOffNote}
            onChange={(e) => setWriteOffNote(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer className="gap-2 justify-content-start">
        <Button
          variant="danger"
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <Spinner animation="border" size="sm" role="status" />
          ) : (
            <>
              <i className="fa fa-ban me-2"></i>
              Write Off
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
    <AppToast
      show={toast.show}
      onClose={hideToast}
      variant={toast.variant}
      message={toast.message}
    />
    </>
  );
}
